export const POST_SAVE_VEHICLE_SALE_INFO = "POST_SAVE_VEHICLE_SALE_INFO";
export const POST_SAVE_VEHICLE_SALE_INFO_SUCCESS =
  "POST_SAVE_VEHICLE_SALE_INFO_SUCCESS";
export const POST_SAVE_VEHICLE_SALE_INFO_ERROR =
  "POST_SAVE_VEHICLE_SALPOST_SAVE_VEHICLE_SALE_INFO_ERRORE_INFO";

export const GET_BUYERS = "GET_BUYERS";
export const GET_BUYERS_SUCCESS = "GET_BUYERS_SUCCESS";
export const GET_BUYERS_ERROR = "GET_BUYERS_ERROR";
